import { FormikHelpers, FormikProps } from 'formik';

import { Income } from './model';
import { API_ACCOUNT_FINANCE_INCOME, API_ACCOUNT_DETAIL_FINANCE_INCOME, API_ACCOUNT_CALC_INCOME } from 'api/endpoints';
import { action, observable, toJS } from 'mobx';
import { RootStore } from 'stores/rootStore';
import { FormStore } from 'stores/formStore';
import { RentModalsStore } from 'stores/workflowStores/finances/rentModalsStore';
import { transformToFormErrors } from 'helpers/helpers';
import { SingleValueResponse } from 'common/interfaces';

class CurrentIncomeStore extends FormStore<Income> {
  accountId: string;
  rentModalsStore: RentModalsStore;
  detailMode?: boolean;

  constructor(rootStore: RootStore, accountId: string, rentModalsStore: RentModalsStore, detailMode?: boolean) {
    super(rootStore);
    this.accountId = accountId;
    this.rentModalsStore = rentModalsStore;
    this.detailMode = detailMode;
  }

  @observable calculatedPensionClient: number | null = null;

  @observable calculatedPensionPartner: number | null = null;

  @observable setCalculatedPensionClient = (pension: number) => (this.calculatedPensionClient = pension);

  @observable setCalculatedPensionPartner = (pension: number) => (this.calculatedPensionPartner = pension);

  @action fetchIncome = async () => {
    this.rentModalsStore.setLoading(true);
    this.fetchData(
      this.detailMode ? API_ACCOUNT_DETAIL_FINANCE_INCOME(this.accountId) : API_ACCOUNT_FINANCE_INCOME(this.accountId),
    );
    this.rentModalsStore.setLoading(false);
  };

  calcSubmit = async (formikProps: FormikProps<Income>, forPartner: boolean) => {
    const { post } = this.rootStore.stores.apiStore;
    const { values, setFieldValue } = formikProps;
    const target = forPartner ? 'partnerData' : 'clientData';

    const dataForCalculation = toJS(forPartner ? { ...values.partnerData } : { ...values.clientData });

    const response = await post<SingleValueResponse<number>>(API_ACCOUNT_CALC_INCOME, dataForCalculation);

    const { errors, data } = response!;

    if (data) {
      setFieldValue(`${target}.netIncome.value`, data.value);
    }
    if (errors) {
      this.setErrors(errors, formikProps);
      const formikErrors = transformToFormErrors(errors, 2);
      for (let [key, value] of Object.entries(formikErrors)) {
        formikProps.setFieldError(`${target}.${key}`, value);
      }
    }
  };

  handleSubmit = async (values: Income, formikHelpers: FormikHelpers<Income>) => {
    const { onNextRentTab } = this.rentModalsStore;

    const ok = await this.submitData(
      this.detailMode ? API_ACCOUNT_DETAIL_FINANCE_INCOME(this.accountId) : API_ACCOUNT_FINANCE_INCOME(this.accountId),
      values,
      {
        validationPrefixDepth: 3,
        singleValueResponse: true,
        formikHelpers: formikHelpers,
      },
    );
    ok && onNextRentTab();
  };
}

export default CurrentIncomeStore;
